<template>
  <div id="grid-documento-diario-progreso">
    <v-container grid-list-xl fluid>
      <v-layout justify-center>
        <v-flex lg12>
          <v-spacer></v-spacer>
          <v-data-table
            :headers="headers"
            :items="itemsDocumento"
            :pagination.sync="miPaginacion"
            hide-actions
            class="elevation-1"
          >
            <template v-slot:items="props">
              <td class="text-xs-left">{{ props.item.id }}</td>
              <td class="text-xs-left" nowrap>
                {{ props.item.subItemId.nivel }}
              </td>
              <td class="text-xs-left">
                {{ props.item.subItemId.tipoMaterial }}
              </td>
              <td class="text-xs-left">
                {{ props.item.subItemId.tipoPrueba }}
              </td>
              <td class="text-xs-left">{{ props.item.subItemId.area }}</td>
              <td class="text-xs-left">
                {{ props.item.subItemId.tipoDocumento }}
              </td>
              <td class="text-xs-left" nowrap>
                {{ props.item.fechaProgreso }}
              </td>
              <td v-if="cantidadDisable" class="text-xs-left">
                {{ props.item.cantidad }}
              </td>
              <td class="text-xs-left">
                <v-text-field
                  v-if="!cantidadDisable"
                  label="0"
                  :value="props.item.cantidad"
                  @change="updateCantidad($event)"
                  @blur="saveCantidad(props.item.id, $event)"
                  solo
                  @keypress="restrictChars($event)"
                ></v-text-field>
              </td>
            </template>
          </v-data-table>
          <!-- PAGINACION -->
          <v-flex xs12 sm6>
            <v-text-field
              value=""
              label="Total de Registros"
              v-model="miPaginacion.totalItems"
              disabled
            ></v-text-field>
          </v-flex>
          <div class="pt-2">
            <v-pagination
              v-model="miPaginacion.page"
              :length="numPaginas"
              :total-visible="7"
              circle
            ></v-pagination>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
import axios from "axios";
export default {
  name: "grid-documento-diario-progreso",
  components: {},
  props: {
    itemsDocumento: "",
  },

  data() {
    return {
      miPaginacion: {
        rowsPerPage: 20,
        page: 0,
      },
      cantidadDisable: false,
      loading: false,
      contratoId: "",
      usuario: "",
      tipoUsuario: "",
      proceso: "",
      itemsProgreso: [],
      headers: [
        { text: "Id", sortable: false, value: "id" },
        { text: "Nivel", align: "left", sortable: false, value: "nivel" },
        { text: "Tipo de Material", sortable: false, value: "tipoDocumento" },
        { text: "Tipo de Prueba", sortable: false, value: "fechaEntrega" },
        { text: "Area", sortable: false, value: "fechaMaqueta" },
        { text: "Tipo Documento/Forma", sortable: false, value: "fechaAcceso" },
        { text: "Fecha Progreso", sortable: false, value: "fechaProgreso" },
        { text: "Cantidad", sortable: false, value: "fechaActualizacion" },
      ],
      cantidad: "",
    };
  },
  created() {
    this.proceso = this.$store.getters.subProTabSelectedStored;
    this.contratoId = this.$store.getters.contratoStored;
    this.usuario = this.$store.getters.userLogged.id;
    this.tipoUsuario = this.$store.getters.userLogged.tipo;

    if (this.tipoUsuario != "PROVEEDOR") {
      this.cantidadDisable = true;
    }
  },
  watch: {
    itemsDocumento(val) {
      this.miPaginacion.totalItems = this.itemsDocumento.length;
    },
  },
  mounted() {},
  computed: {
    numPaginas() {
      if (
        this.miPaginacion.rowsPerPage == null ||
        this.miPaginacion.totalItems == null
      ) {
        return 0;
      }

      return Math.ceil(
        this.miPaginacion.totalItems / this.miPaginacion.rowsPerPage
      );
    },
  },
  methods: {
    //SOLO NUMEROS
    restrictChars($event) {
      if (
        $event.charCode === 0 ||
        /\d/.test(String.fromCharCode($event.charCode))
      ) {
        return true;
      } else {
        $event.preventDefault();
      }
    },
    updateCantidad(val) {
      this.cantidad = val;
    },
    saveCantidad(idIn, e) {
      let cant = e.currentTarget._value;
      let subProceso = this.$store.getters.subProTabSelectedStored;
      let idContrato = this.$store.getters.contratoStored;

      this.body = {
        id: idIn,
        cantidad: cant,
        subProceso: subProceso,
        idContrato: idContrato,
      };
      axios
        .put("/progreso", this.body)
        .then(function (response) {
          window.getApp.$emit("APP_SAVE");
          response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
};
</script>
